export const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
export const colors = ['hsl(289, 70%, 50%)', 'hsl(218, 70%, 50%)', 'hsl(44, 70%, 50%)', 'hsl(281, 70%, 50%)', 'hsl(134, 70%, 50%)'];

export const groupBy = (xs: any, key: string) => {
  return xs.reduce((rv: any, x: any) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
